
import http from './http.service';
import { useUserStore } from '../stores/UserStore';

export class FileService {

  getAll() {
    return http.get('/images/' + this.getSelectedCompanyId()).then(x => x.data);
  }

  getReview() {
    return http.get('/images/' + this.getSelectedCompanyId() + '?status=2').then(x => x.data);
  }

  getApproved() {
    return http.get('/images/' + this.getSelectedCompanyId() + '?status=3,6').then(x => x.data);
  }

  getRejected() {
    return http.get('/images/' + this.getSelectedCompanyId() + '?status=4').then(x => x.data);
  }

  save(data) {
    return http.post('/images/meta', data);
  }

  updateVisibility(imageId, visible) {
    return http.put('/images/meta/visibility', { id: imageId, visible }).then(x => x.data)
  }

  delete(data) {
    const url = '/images/' + this.getSelectedCompanyId() + '/' + (Array.isArray(data) ? 'multiple' : data.id);
    return http.delete(url, { data: data });
  }

  logImageClick(image) {
    return http.post('/click/' + image.id);
  }

  // Private
  getSelectedCompanyId() {
    const userStore = useUserStore();
    return userStore.selectedCompany.id;
  }
}
